<template>
  <div class="home_page" ref="homePage">
    <div :style="{ transform: `scale(${scale})` }" style="transform-origin: top center" class="content" ref="content">
      <div class="top">
        <img src="@/assets/logo_name.png" alt="">
        <div class="platform">抖店</div>
      </div>
      <div class="middle">
        <plug-download />
        <teaching-window :teachingWindowGif="teachingWindowGif" />
      </div>
      <!-- 浏览器 -->
      <div class="footer">
        <browser-category @changeBrowser="changeBrowser" />
      </div>
    </div>
    <!-- 客服 -->
    <service-box />
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import teach360 from '@/assets/teach/360.gif'
import teach360jisu from '@/assets/teach/360_jisu.gif'
import teach2345 from '@/assets/teach/2345.gif'
import teachChrome from '@/assets/teach/chrome.gif'
import teachSougou from '@/assets/teach/sougou.gif'
import teachEdge from '@/assets/teach/edge.gif'
import teachQq from '@/assets/teach/qq.gif'

const homePage = ref(null)
const content = ref(null)
const teachingWindowGif = ref(teach360)
const browserList = ref({
  '360浏览器': teach360,
  '360极速浏览器': teach360jisu,
  '2345浏览器': teach2345,
  '谷歌浏览器': teachChrome,
  '搜狗浏览器': teachSougou,
  'Edge': teachEdge,
  'QQ浏览器': teachQq,
})

// const teachingWindow = ref(null)
const scale = ref(1)

onMounted(() => {
  window.addEventListener('resize', mainWidth())
  setTimeout(mainWidth(), 50);
})

function mainWidth() {
  // const mainWidth = homePage.value.clientWidth;
  // const mainScale = mainWidth / 1708;
  // if (mainWidth < 1600) {
  //   scale.value = 1;
  //   content.value.style.position = 'absolute'
  //   content.value.style.left = '0'
  //   content.value.style.top = '0'
  // }
  // else {
  //   scale.value = mainScale;
  //   content.value.style.position = 'static'
  //   content.value.style.left = '0'
  //   content.value.style.top = '0'
  // }
}

const changeBrowser = (value) => {
  teachingWindowGif.value = browserList.value[value.name]
}

onUnmounted(() => {
  window.removeEventListener("resize", mainWidth());
})
</script>

<style lang="less" scoped>
@import './index.less';
</style>